import { createFileRoute } from "@tanstack/react-router";
import { SystemMonitorPage } from "@/features/admin/system-monitor/system-monitor-page";

export const Route = createFileRoute("/admin/system-monitor")({
  component: RouteComponent,
  ssr: false,
});

function RouteComponent() {
  return <SystemMonitorPage />;
}
